(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement-dismissible]').forEach(function (bar) {
      var key = bar.getAttribute('data-key');
      try { if (key && localStorage.getItem(key) === '1') { bar.style.display = 'none'; return; } } catch (e) {}
      var btn = bar.querySelector('[data-announcement-close]');
      if (btn) btn.addEventListener('click', function () {
        bar.style.display = 'none';
        try { if (key) localStorage.setItem(key, '1'); } catch (e) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var listEl = section.querySelector('[data-reviews-list]');
      if (!listEl) return;

      var initial = parseInt(section.getAttribute('data-reviews-initial'), 10) || 8;
      var state = { sort: 'recent', star: null, expanded: false };

      var showMore = section.querySelector('[data-reviews-showmore]');
      var sortSelect = section.querySelector('[data-reviews-sort]');
      var bars = Array.prototype.slice.call(section.querySelectorAll('[data-reviews-bar]'));
      var filterStatus = section.querySelector('[data-reviews-filter-status]');
      var filterLabel = section.querySelector('[data-reviews-filter-label]');
      var emptyFilter = section.querySelector('[data-reviews-empty-filter]');
      var loadMore = section.querySelector('[data-reviews-loadmore]');
      var showMoreTpl = (showMore && showMore.getAttribute('data-label')) || 'Show all __N__ reviews';

      // Snapshot the current review items with their sort keys. Re-run after the
      // API appends more so freshly fetched reviews join the sort/filter.
      function collect() {
        return Array.prototype.slice.call(listEl.querySelectorAll('[data-review-item]')).map(function (el, i) {
          var ts = Date.parse(el.getAttribute('data-date') || '');
          el.classList.remove('is-extra');
          return { el: el, rating: parseInt(el.getAttribute('data-rating'), 10) || 0, ts: isNaN(ts) ? null : ts, index: i };
        });
      }

      // Natural metaobject order ≈ newest first, so it's the fallback when dates
      // are missing/unparseable.
      function byRecent(a, b) {
        if (a.ts !== null && b.ts !== null && a.ts !== b.ts) return b.ts - a.ts;
        return a.index - b.index;
      }
      function comparator() {
        switch (state.sort) {
          case 'oldest':   return function (a, b) { return -byRecent(a, b); };
          case 'positive': return function (a, b) { return (b.rating - a.rating) || byRecent(a, b); };
          case 'critical': return function (a, b) { return (a.rating - b.rating) || byRecent(a, b); };
          default:         return byRecent;
        }
      }

      function render() {
        var items = collect();
        var cmp = comparator();
        // Hold 1–2★ back from the first page unless the shopper opted in — either
        // by filtering to a low star, or by choosing the "Critical" sort.
        var suppress = state.star === null && state.sort !== 'critical';
        var ordered, lockedVisible;

        if (state.star !== null) {
          ordered = items.filter(function (it) { return it.rating === state.star; }).sort(cmp);
        } else if (suppress) {
          var primary = items.filter(function (it) { return it.rating >= 3; }).sort(cmp);
          var secondary = items.filter(function (it) { return it.rating <= 2; }).sort(cmp);
          ordered = primary.concat(secondary);
          // Never reveal a 1–2★ on the first page, even with fewer than `initial`
          // primaries — but don't leave the page blank if every loaded review is low.
          lockedVisible = primary.length ? Math.min(initial, primary.length) : Math.min(initial, ordered.length);
        } else {
          ordered = items.slice().sort(cmp);
        }

        var frag = document.createDocumentFragment();
        ordered.forEach(function (it) { frag.appendChild(it.el); });
        listEl.appendChild(frag);

        var visible = state.expanded ? ordered.length
          : (lockedVisible !== undefined ? lockedVisible : Math.min(initial, ordered.length));
        ordered.forEach(function (it, i) { it.el.hidden = i >= visible; });

        if (emptyFilter) {
          emptyFilter.hidden = ordered.length !== 0;
          if (ordered.length === 0) {
            var etpl = emptyFilter.getAttribute('data-label') || 'No __N__-star reviews to show.';
            emptyFilter.textContent = etpl.replace('__N__', state.star == null ? '' : state.star);
          }
        }

        if (showMore) {
          if (!state.expanded && ordered.length - visible > 0) {
            showMore.hidden = false;
            showMore.textContent = showMoreTpl.replace('__N__', ordered.length);
          } else {
            showMore.hidden = true;
          }
        }
      }

      function applyBarState() {
        bars.forEach(function (b) {
          var on = state.star !== null && parseInt(b.getAttribute('data-star'), 10) === state.star;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (filterStatus) {
          filterStatus.hidden = state.star === null;
          if (state.star !== null && filterLabel) {
            var tpl = filterLabel.getAttribute('data-label') || '__N__ star';
            filterLabel.textContent = tpl.replace('__N__', state.star);
          }
        }
      }

      bars.forEach(function (b) {
        b.addEventListener('click', function () {
          var star = parseInt(b.getAttribute('data-star'), 10);
          state.star = state.star === star ? null : star;
          state.expanded = false;
          applyBarState();
          render();
        });
      });
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          state.sort = sortSelect.value || 'recent';
          state.expanded = false;
          render();
        });
      }
      if (showMore) {
        showMore.addEventListener('click', function () {
          state.expanded = true;
          render();
          if (loadMore) loadMore.hidden = false;
        });
      }

      applyBarState();
      render();

      var apiOn = section.getAttribute('data-reviews-api') === 'true';
      if (!apiOn) return;
      var asin = section.getAttribute('data-asin') || '';

      // Load-more: fetch the next page from the App Proxy and append.
      if (loadMore && listEl) {
        loadMore.addEventListener('click', function () {
          var page = parseInt(loadMore.getAttribute('data-next-page'), 10) || 2;
          loadMore.disabled = true;
          var url = '/apps/reviews/api/reviews?page=' + page + '&limit=50' + (asin ? '&asin=' + encodeURIComponent(asin) : '');
          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              (data.reviews || []).forEach(function (rev) { listEl.appendChild(renderReview(rev)); });
              render();
              var p = data.pagination || {};
              if (p.page && p.totalPages && p.page < p.totalPages) {
                loadMore.setAttribute('data-next-page', String(p.page + 1));
                loadMore.disabled = false;
              } else {
                loadMore.remove();
              }
            })
            .catch(function () { loadMore.disabled = false; });
        });
      }

      // Q&A widget.
      var qa = section.querySelector('[data-reviews-qa]');
      var form = section.querySelector('[data-qa-form]');
      if (qa && form) {
        qa.hidden = false;
        var input = section.querySelector('[data-qa-input]');
        var submit = section.querySelector('[data-qa-submit]');
        var answer = section.querySelector('[data-qa-answer]');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = (input.value || '').trim();
          if (!q) return;
          submit.disabled = true;
          answer.hidden = false;
          answer.removeAttribute('data-confidence');
          answer.textContent = '…';
          fetch('/apps/reviews/api/review-qa', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ asin: asin, question: q })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              answer.textContent = '';
              answer.setAttribute('data-confidence', data.confidence || '');
              var p = document.createElement('p');
              p.textContent = data.answer || '';
              answer.appendChild(p);
              var n = (data.sourceReviewIds || []).length;
              if (data.confidence || n) {
                var meta = document.createElement('span');
                meta.className = 'reviews__qa-conf';
                meta.textContent = [data.confidence ? 'Confidence: ' + data.confidence : '', n ? 'Based on ' + n + ' reviews' : ''].filter(Boolean).join(' · ');
                answer.appendChild(meta);
              }
            })
            .catch(function () { answer.textContent = ''; })
            .finally(function () { submit.disabled = false; });
        });
      }

      function escapeHtml(s) {
        var d = document.createElement('div');
        d.textContent = s == null ? '' : String(s);
        return d.innerHTML;
      }

      function renderReview(rev) {
        var li = document.createElement('li');
        li.className = 'reviews__item';
        li.setAttribute('data-review-item', '');
        li.setAttribute('data-rating', String(Number(rev.rating) || 0));
        if (rev.date) li.setAttribute('data-date', rev.date);
        var pct = Math.round((Number(rev.rating) || 0) / 5 * 100);
        var stars = '<span class="stars" role="img" aria-label="' + (Number(rev.rating) || 0) + ' out of 5 stars">'
          + '<span class="stars__track" aria-hidden="true">★★★★★</span>'
          + '<span class="stars__fill" aria-hidden="true" style="width:' + pct + '%">★★★★★</span></span>';
        var html = '<div class="reviews__item-head">' + stars
          + (rev.date ? '<span class="reviews__date">' + escapeHtml(rev.date) + '</span>' : '') + '</div>';
        if (rev.title) html += '<h4 class="reviews__item-title">' + escapeHtml(rev.title) + '</h4>';
        html += '<div class="reviews__byline">'
          + (rev.author ? '<span class="reviews__author">' + escapeHtml(rev.author) + '</span>' : '')
          + (rev.verified ? '<span class="reviews__tag reviews__tag--verified">Verified buyer</span>' : '')
          + (rev.isVine ? '<span class="reviews__tag reviews__tag--vine">Vine review</span>' : '')
          + '</div>';
        if (rev.body) html += '<p class="reviews__body">' + escapeHtml(rev.body) + '</p>';
        if (rev.images && rev.images.length) {
          html += '<div class="reviews__photos">' + rev.images.slice(0, 6).map(function (src) {
            return '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" width="120" height="120">';
          }).join('') + '</div>';
        }
        li.innerHTML = html;
        return li;
      }
    }

    document.querySelectorAll('[data-reviews]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
